import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const TransactionHistoryModal = ({ isOpen, onClose, agentId }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [dateRange, setDateRange] = useState('30days');
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  // Mock transaction data
  const mockTransactions = [
    {
      id: 'txn_001',
      date: '2024-11-20T10:30:00',
      customer: 'Sarah Johnson',
      customerId: 'cust_001',
      type: 'send',
      fromCurrency: 'USD',
      toCurrency: 'EUR',
      sendAmount: 1000,
      receiveAmount: 920,
      exchangeRate: 0.92,
      fee: 15,
      status: 'completed',
      recipient: 'Maria Schmidt',
      recipientCountry: 'Germany',
      reference: 'Family Support',
      paymentMethod: 'Bank Transfer',
      commission: 35
    },
    {
      id: 'txn_002',
      date: '2024-11-19T15:45:00',
      customer: 'Michael Chen',
      customerId: 'cust_002',
      type: 'send',
      fromCurrency: 'CAD',
      toCurrency: 'PHP',
      sendAmount: 500,
      receiveAmount: 19750,
      exchangeRate: 39.5,
      fee: 8,
      status: 'completed',
      recipient: 'Juan dela Cruz',
      recipientCountry: 'Philippines',
      reference: 'Monthly Allowance',
      paymentMethod: 'Cash Pickup',
      commission: 17.5
    },
    {
      id: 'txn_003',
      date: '2024-11-19T09:20:00',
      customer: 'Elena Rodriguez',
      customerId: 'cust_003',
      type: 'send',
      fromCurrency: 'EUR',
      toCurrency: 'MXN',
      sendAmount: 300,
      receiveAmount: 6180,
      exchangeRate: 20.6,
      fee: 5,
      status: 'pending',
      recipient: 'Carlos Mendoza',
      recipientCountry: 'Mexico',
      reference: 'Gift',
      paymentMethod: 'Mobile Wallet',
      commission: 10.5
    },
    {
      id: 'txn_004',
      date: '2024-11-18T14:10:00',
      customer: 'Ahmed Hassan',
      customerId: 'cust_008',
      type: 'send',
      fromCurrency: 'EGP',
      toCurrency: 'USD',
      sendAmount: 15000,
      receiveAmount: 487.8,
      exchangeRate: 0.03252,
      fee: 20,
      status: 'completed',
      recipient: 'John Smith',
      recipientCountry: 'United States',
      reference: 'Business Payment',
      paymentMethod: 'Bank Transfer',
      commission: 17.07
    },
    {
      id: 'txn_005',
      date: '2024-11-18T11:30:00',
      customer: 'Fatima Al-Rashid',
      customerId: 'cust_005',
      type: 'send',
      fromCurrency: 'AED',
      toCurrency: 'INR',
      sendAmount: 2000,
      receiveAmount: 45600,
      exchangeRate: 22.8,
      fee: 12,
      status: 'completed',
      recipient: 'Priya Sharma',
      recipientCountry: 'India',
      reference: 'Family Support',
      paymentMethod: 'Bank Transfer',
      commission: 70
    },
    {
      id: 'txn_006',
      date: '2024-11-17T16:55:00',
      customer: 'David Kim',
      customerId: 'cust_006',
      type: 'send',
      fromCurrency: 'KRW',
      toCurrency: 'USD',
      sendAmount: 1300000,
      receiveAmount: 982.46,
      exchangeRate: 0.000755,
      fee: 18,
      status: 'completed',
      recipient: 'Emily Johnson',
      recipientCountry: 'United States',
      reference: 'Education Fees',
      paymentMethod: 'Wire Transfer',
      commission: 34.39
    },
    {
      id: 'txn_007',
      date: '2024-11-16T13:20:00',
      customer: 'Sarah Johnson',
      customerId: 'cust_001',
      type: 'send',
      fromCurrency: 'USD',
      toCurrency: 'GBP',
      sendAmount: 750,
      receiveAmount: 592.5,
      exchangeRate: 0.79,
      fee: 12,
      status: 'failed',
      recipient: 'Thomas Brown',
      recipientCountry: 'United Kingdom',
      reference: 'Investment',
      paymentMethod: 'Bank Transfer',
      commission: 0,
      failureReason: 'Insufficient funds'
    },
    {
      id: 'txn_008',
      date: '2024-11-15T10:05:00',
      customer: 'Michael Chen',
      customerId: 'cust_002',
      type: 'send',
      fromCurrency: 'CAD',
      toCurrency: 'AUD',
      sendAmount: 1500,
      receiveAmount: 1665,
      exchangeRate: 1.11,
      fee: 20,
      status: 'completed',
      recipient: 'Sophie Wilson',
      recipientCountry: 'Australia',
      reference: 'Property Payment',
      paymentMethod: 'Bank Transfer',
      commission: 52.5
    },
    {
      id: 'txn_009',
      date: '2024-11-15T08:40:00',
      customer: 'Elena Rodriguez',
      customerId: 'cust_003',
      type: 'receive',
      fromCurrency: 'USD',
      toCurrency: 'EUR',
      sendAmount: 500,
      receiveAmount: 460,
      exchangeRate: 0.92,
      fee: 8,
      status: 'completed',
      recipient: 'Elena Rodriguez',
      recipientCountry: 'Spain',
      reference: 'Freelance Payment',
      paymentMethod: 'Bank Transfer',
      commission: 17.5
    },
    {
      id: 'txn_010',
      date: '2024-11-14T17:25:00',
      customer: 'Ahmed Hassan',
      customerId: 'cust_008',
      type: 'send',
      fromCurrency: 'EGP',
      toCurrency: 'SAR',
      sendAmount: 10000,
      receiveAmount: 1224.49,
      exchangeRate: 0.122449,
      fee: 15,
      status: 'in_review',
      recipient: 'Abdullah Al-Saud',
      recipientCountry: 'Saudi Arabia',
      reference: 'Business Transfer',
      paymentMethod: 'Bank Transfer',
      commission: 0,
      reviewReason: 'Large amount verification'
    }
  ];

  const getFilteredTransactions = () => {
    return mockTransactions?.filter(txn => {
      const matchesSearch = txn?.customer?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                           txn?.recipient?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                           txn?.id?.toLowerCase()?.includes(searchTerm?.toLowerCase());
      const matchesStatus = filterStatus === 'all' || txn?.status === filterStatus;
      const matchesType = filterType === 'all' || txn?.type === filterType;
      
      // Date range filter
      const txnDate = new Date(txn?.date);
      const now = new Date();
      let matchesDate = true;
      
      switch (dateRange) {
        case '7days':
          matchesDate = (now - txnDate) <= 7 * 24 * 60 * 60 * 1000;
          break;
        case '30days':
          matchesDate = (now - txnDate) <= 30 * 24 * 60 * 60 * 1000;
          break;
        case '90days':
          matchesDate = (now - txnDate) <= 90 * 24 * 60 * 60 * 1000;
          break;
        default:
          matchesDate = true;
      }
      
      return matchesSearch && matchesStatus && matchesType && matchesDate;
    });
  };

  const filteredTransactions = getFilteredTransactions();

  const getStatusBadge = (status) => {
    const styles = {
      completed: 'bg-success/10 text-success border-success/20',
      pending: 'bg-warning/10 text-warning border-warning/20',
      in_review: 'bg-info/10 text-info border-info/20',
      failed: 'bg-error/10 text-error border-error/20'
    };
    return styles?.[status] || styles?.pending;
  };

  const getStatusIcon = (status) => {
    const icons = {
      completed: 'CheckCircle',
      pending: 'Clock',
      in_review: 'AlertCircle',
      failed: 'XCircle'
    };
    return icons?.[status] || 'Clock';
  };

  const calculateTotalStats = () => {
    const completed = filteredTransactions?.filter(t => t?.status === 'completed');
    const totalVolume = completed?.reduce((sum, t) => sum + (t?.sendAmount || 0), 0);
    const totalCommission = completed?.reduce((sum, t) => sum + (t?.commission || 0), 0);
    
    return {
      totalTransactions: filteredTransactions?.length,
      completedTransactions: completed?.length,
      totalVolume: totalVolume?.toFixed(2),
      totalCommission: totalCommission?.toFixed(2)
    };
  };

  const stats = calculateTotalStats();

  const handleViewTransaction = (transaction) => {
    setSelectedTransaction(transaction);
  };

  const handleCloseDetails = () => {
    setSelectedTransaction(null);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-background rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Transaction History</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Complete transaction record and analytics
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Stats Summary */}
        <div className="p-6 border-b border-border">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-muted-foreground">Total Transactions</span>
                <Icon name="List" size={16} className="text-primary" />
              </div>
              <div className="text-2xl font-bold text-foreground">{stats?.totalTransactions}</div>
            </div>
            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-muted-foreground">Completed</span>
                <Icon name="CheckCircle" size={16} className="text-success" />
              </div>
              <div className="text-2xl font-bold text-foreground">{stats?.completedTransactions}</div>
            </div>
            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-muted-foreground">Total Volume</span>
                <Icon name="TrendingUp" size={16} className="text-info" />
              </div>
              <div className="text-2xl font-bold text-foreground">${stats?.totalVolume}</div>
            </div>
            <div className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-muted-foreground">Commission Earned</span>
                <Icon name="DollarSign" size={16} className="text-success" />
              </div>
              <div className="text-2xl font-bold text-foreground">${stats?.totalCommission}</div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="p-6 border-b border-border space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="md:col-span-2">
              <Input
                placeholder="Search by customer, recipient, or transaction ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e?.target?.value)}
                icon="Search"
              />
            </div>
            <Select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e?.target?.value)}
              options={[
                { value: 'all', label: 'All Status' },
                { value: 'completed', label: 'Completed' },
                { value: 'pending', label: 'Pending' },
                { value: 'in_review', label: 'In Review' },
                { value: 'failed', label: 'Failed' }
              ]}
            />
            <Select
              value={dateRange}
              onChange={(e) => setDateRange(e?.target?.value)}
              options={[
                { value: '7days', label: 'Last 7 Days' },
                { value: '30days', label: 'Last 30 Days' },
                { value: '90days', label: 'Last 90 Days' },
                { value: 'all', label: 'All Time' }
              ]}
            />
          </div>
          <div className="flex items-center justify-between">
            <Select
              value={filterType}
              onChange={(e) => setFilterType(e?.target?.value)}
              options={[
                { value: 'all', label: 'All Types' },
                { value: 'send', label: 'Send Money' },
                { value: 'receive', label: 'Receive Money' }
              ]}
            />
            <div className="text-sm text-muted-foreground">
              Showing {filteredTransactions?.length} transactions
            </div>
          </div>
        </div>

        {/* Transaction List */}
        <div className="flex-1 overflow-auto p-6">
          {selectedTransaction ? (
            // Transaction Details View
            (<div className="space-y-6">
              <div className="flex items-center justify-between">
                <Button
                  variant="ghost"
                  onClick={handleCloseDetails}
                  className="flex items-center space-x-2"
                >
                  <Icon name="ArrowLeft" size={16} />
                  <span>Back to List</span>
                </Button>
              </div>
              <div className="bg-muted/50 rounded-lg p-6 space-y-6">
                <div className="flex items-start justify-between">
                  <div className="space-y-2">
                    <h3 className="text-2xl font-semibold text-foreground">
                      Transaction Details
                    </h3>
                    <div className="flex items-center space-x-2">
                      <span className="text-sm text-muted-foreground">ID: {selectedTransaction?.id}</span>
                      <span className={`px-2 py-1 rounded text-xs font-medium border ${getStatusBadge(selectedTransaction?.status)}`}>
                        {selectedTransaction?.status?.toUpperCase()}
                      </span>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-muted-foreground">Date & Time</div>
                    <div className="text-sm font-medium text-foreground">
                      {new Date(selectedTransaction?.date)?.toLocaleString()}
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <h4 className="font-semibold text-foreground">Sender Information</h4>
                    <div className="space-y-3 bg-background rounded-lg p-4">
                      <div>
                        <div className="text-sm text-muted-foreground">Customer</div>
                        <div className="text-sm font-medium text-foreground">{selectedTransaction?.customer}</div>
                      </div>
                      <div>
                        <div className="text-sm text-muted-foreground">Customer ID</div>
                        <div className="text-sm font-medium text-foreground">{selectedTransaction?.customerId}</div>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <h4 className="font-semibold text-foreground">Recipient Information</h4>
                    <div className="space-y-3 bg-background rounded-lg p-4">
                      <div>
                        <div className="text-sm text-muted-foreground">Recipient</div>
                        <div className="text-sm font-medium text-foreground">{selectedTransaction?.recipient}</div>
                      </div>
                      <div>
                        <div className="text-sm text-muted-foreground">Country</div>
                        <div className="text-sm font-medium text-foreground">{selectedTransaction?.recipientCountry}</div>
                      </div>
                      <div>
                        <div className="text-sm text-muted-foreground">Payment Method</div>
                        <div className="text-sm font-medium text-foreground">{selectedTransaction?.paymentMethod}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-4 bg-background rounded-lg p-4">
                  <h4 className="font-semibold text-foreground">Transaction Details</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span className="text-sm text-muted-foreground">Send Amount</span>
                        <span className="text-sm font-medium text-foreground">
                          {selectedTransaction?.sendAmount} {selectedTransaction?.fromCurrency}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-muted-foreground">Exchange Rate</span>
                        <span className="text-sm font-medium text-foreground">
                          1 {selectedTransaction?.fromCurrency} = {selectedTransaction?.exchangeRate} {selectedTransaction?.toCurrency}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-muted-foreground">Transfer Fee</span>
                        <span className="text-sm font-medium text-foreground">
                          {selectedTransaction?.fee} {selectedTransaction?.fromCurrency}
                        </span>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span className="text-sm text-muted-foreground">Receive Amount</span>
                        <span className="text-sm font-medium text-success">
                          {selectedTransaction?.receiveAmount} {selectedTransaction?.toCurrency}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-muted-foreground">Your Commission</span>
                        <span className="text-sm font-medium text-success">
                          ${selectedTransaction?.commission}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-sm text-muted-foreground">Reference</span>
                        <span className="text-sm font-medium text-foreground">
                          {selectedTransaction?.reference}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {selectedTransaction?.failureReason && (
                  <div className="bg-error/10 border border-error/20 rounded-lg p-4">
                    <div className="flex items-center space-x-2 text-error mb-2">
                      <Icon name="AlertCircle" size={16} />
                      <span className="font-medium">Transaction Failed</span>
                    </div>
                    <p className="text-sm text-error/80">{selectedTransaction?.failureReason}</p>
                  </div>
                )}

                {selectedTransaction?.reviewReason && (
                  <div className="bg-info/10 border border-info/20 rounded-lg p-4">
                    <div className="flex items-center space-x-2 text-info mb-2">
                      <Icon name="AlertCircle" size={16} />
                      <span className="font-medium">Under Review</span>
                    </div>
                    <p className="text-sm text-info/80">{selectedTransaction?.reviewReason}</p>
                  </div>
                )}
              </div>
              <div className="flex justify-end space-x-3">
                <Button variant="outline">Download Receipt</Button>
                <Button variant="outline">Contact Support</Button>
                {selectedTransaction?.status === 'pending' && (
                  <Button variant="primary">Track Status</Button>
                )}
              </div>
            </div>)
          ) : (
            // Transaction Table View
            (<div className="space-y-4">
              {filteredTransactions?.map((transaction) => (
                <div
                  key={transaction?.id}
                  className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors cursor-pointer"
                  onClick={() => handleViewTransaction(transaction)}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex items-start space-x-4 flex-1">
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                        transaction?.status === 'completed' ? 'bg-success/10' :
                        transaction?.status === 'pending' ? 'bg-warning/10' :
                        transaction?.status === 'failed'? 'bg-error/10' : 'bg-info/10'
                      }`}>
                        <Icon 
                          name={getStatusIcon(transaction?.status)} 
                          size={20}
                          className={
                            transaction?.status === 'completed' ? 'text-success' :
                            transaction?.status === 'pending' ? 'text-warning' :
                            transaction?.status === 'failed'? 'text-error' : 'text-info'
                          }
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center space-x-2 mb-1">
                          <span className="font-medium text-foreground">{transaction?.customer}</span>
                          <Icon name="ArrowRight" size={14} className="text-muted-foreground" />
                          <span className="text-sm text-muted-foreground">{transaction?.recipient}</span>
                          <span className={`px-2 py-0.5 rounded text-xs font-medium border ${getStatusBadge(transaction?.status)}`}>
                            {transaction?.status}
                          </span>
                        </div>
                        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                          <span>{transaction?.id}</span>
                          <span>•</span>
                          <span>{new Date(transaction?.date)?.toLocaleString()}</span>
                          <span>•</span>
                          <span>{transaction?.recipientCountry}</span>
                        </div>
                        <div className="mt-2 text-sm text-muted-foreground">
                          {transaction?.reference}
                        </div>
                      </div>
                    </div>
                    <div className="text-right ml-4">
                      <div className="font-semibold text-foreground">
                        {transaction?.sendAmount} {transaction?.fromCurrency}
                      </div>
                      <div className="text-sm text-success">
                        → {transaction?.receiveAmount} {transaction?.toCurrency}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        Commission: ${transaction?.commission}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {filteredTransactions?.length === 0 && (
                <div className="text-center py-12">
                  <Icon name="Inbox" size={48} className="text-muted-foreground mx-auto mb-4" />
                  <p className="text-muted-foreground">No transactions found matching your filters</p>
                </div>
              )}
            </div>)
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-border flex justify-between">
          <Button variant="outline" onClick={() => {}}>
            <Icon name="Download" size={16} className="mr-2" />
            Export Report
          </Button>
          <Button variant="outline" onClick={onClose}>Close</Button>
        </div>
      </div>
    </div>
  );
};

export default TransactionHistoryModal;